import smoothscroll from "smoothscroll-polyfill";
import SmoothScroll from "smooth-scroll";

export function smooth() {
  smoothscroll.polyfill();

  const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 100,
    updateURL: false,
    offset: () => {
      const header = document.querySelector('#header');
      const sticky = document.querySelector('.js-anchor');
      const headerHeight = header ? header.offsetHeight : 0;
      const stickyHeight = sticky ? sticky.offsetHeight : 0;
      const maxSticky = Math.min(stickyHeight, 148);
      return headerHeight + maxSticky;
    },
  });
}
